import { render, staticRenderFns } from "./lotto_agentgroup.vue?vue&type=template&id=2dba28d6&scoped=true&"
import script from "./lotto_agentgroup.vue?vue&type=script&lang=js&"
export * from "./lotto_agentgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba28d6",
  null
  
)

export default component.exports